import React from 'react';
import { compose } from 'redux';
import { FormattedMessage } from 'translations';
import { reduxForm, Field } from 'redux-form';
import MobileDatetimePicker from 'app/components/base/MobileDatetimePicker';
import { BOOK_TRIP_FORM } from 'app/constants';

// Message constants.
const messages = {
  cancel: { id: 'CANCEL' },
  titleLabel: { id: 'BOOK_TRIP.PICKUP_TIME' },
  setTime: { id: 'MOBILE_SEARCH_FORM.SET_RETURN_TIME' },
};

/**
 * Stateless component for showing pickup date/time picker screen.
 * It will push back to the BTP when date/time selected.
 * @return {Component}
 */
export class MobileReturnDate extends React.Component {
  render() {
    const { minDate, fieldName, notime } = this.props;

    return (
      <Field
        component={MobileDatetimePicker}
        name={fieldName}
        timeTitle={<FormattedMessage {...messages.setTime} />}
        minDate={minDate}
        onSelect={(e) => {
          this.props.handleDateSelected(e);
        }}
        notime={notime}
      />
    );
  }
}

export default compose(
  reduxForm({
    form: BOOK_TRIP_FORM,
    destroyOnUnmount: false
  })
)(MobileReturnDate);
